import { useQuery } from '@tanstack/react-query';
import { UserOrganizationsData } from '@/app/api/user/organizations/types';
import { Api } from '@/core/api';

export const QUERY_KEY_CURRENT_USER_ORGS = 'current-user-organizations-data';

export const useCurrentUserOrganizationsData = ({
  userOrganizations,
  enabled,
}: {
  userOrganizations?: UserOrganizationsData['organizations'];
  enabled: boolean;
}) => {
  const { data, ...query } = useQuery({
    queryKey: [QUERY_KEY_CURRENT_USER_ORGS],
    queryFn: () => Api.user.organizations(),
    initialData: userOrganizations ? { organizations: userOrganizations } : undefined,
    enabled,
  });

  return { data, ...query };
};
